import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import StatisticalInfoPaginator from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.vue'
import StatisticalAnalysisViewDetail from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail/statistical-analysis-view-detail.vue'
import { StatisticalAnalysisDelayAndResponseEnum, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import StatisticalAnalysisFilterBy from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-filter-by/statistical-analysis-filter-by.vue'
import { initialStatisticalAnalysisDelaysAndResponseTimeDetailState, StatisticalAnalysisDelaysAndResponseTimeDetailState } from '@/modules/statistical-analysis-module/components/statistical-analysis-delays-and-response-time-detail/statistical-analysis-delays-and-response-time-detail.model'
import { StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo, StatisticsAnalysisDelaysAndResponseTimesTrackingItems } from '@/modules/statistical-analysis-module/views/delays-and-response-time-dossier/delays-and-response-time-dossier.model'
import { StatisticalAnalysisTimesheetItems } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'
import { Nullable } from '@/shared/types/app.types'
import { isNil } from 'lodash'
@Component({
    components: {
        StatisticalInfoPaginator,
        StatisticalAnalysisViewDetail,
        StatisticalAnalysisFilterBy
    }
})
export default class StatisticalAnalysisDelaysAndResponseTimeDetail extends Vue {
    @Prop() readonly externalInfo!: StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo
    @Prop() readonly viewDetailParams!: StatisticalAnalysisViewDetailParams
    @Emit()
    backView(): boolean {
        return true
    }

    state: StatisticalAnalysisDelaysAndResponseTimeDetailState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisDelaysAndResponseTimeDetailState()
    }

    get trackingSelected(): Nullable<StatisticalInfoPaginatorTrackingItems> {
        return {
            key: this.externalInfo.trackingDetailSelected?.key!,
            label: this.externalInfo.trackingDetailSelected?.label!,
            value: this.externalInfo.trackingDetailSelected?.value
        }
    }

    get trackingItems(): StatisticalInfoPaginatorTrackingItems[] {
        const trackingItemsFiltered = this.externalInfo.trackingItems!.filter((item: StatisticalInfoPaginatorTrackingItems) => !isNil(item.value) && item.value > 0)
        return trackingItemsFiltered.map((item:StatisticalInfoPaginatorTrackingItems) => {
            return {
                key: item.key,
                label: item.label,
                value: item.value
            }
        })
    }

    get isTimeTemplateLoading(): boolean {
        return !!this.state.timeSheetId
    }

    created() {
        this.state.selection = this.externalInfo.trackingDetailSelected?.key as StatisticalAnalysisDelayAndResponseEnum
    }

    onBackView(): void {
        this.backView()
    }

    onChangeTrackItem(value: StatisticalInfoPaginatorTrackingItems): void {
        this.state.selection = value.key as StatisticalAnalysisDelayAndResponseEnum
        this.externalInfo.trackingDetailSelected = value as StatisticsAnalysisDelaysAndResponseTimesTrackingItems
    }

    onChangeTimeSheetFilter(value: StatisticalAnalysisTimesheetItems): void {
        this.state.timeSheetId = value
        this.externalInfo.filterTimeSheetId = value
    }
}
